import { getStaticChecklistSalesEmailHeadingImages } from './checklistSalesEmailHeadingImages';

/** Статические PNG для operations-письма (общие заголовки секций + HTML-fallback для title/cta). */
export function getStaticChecklistOperationsEmailHeadingImages() {
  const sales = getStaticChecklistSalesEmailHeadingImages();
  return {
    blocksHeading: sales.blocksHeading,
    readinessHeading: sales.readinessHeading,
    pilotTitle: sales.pilotTitle,
  };
}

export async function buildChecklistOperationsEmailHeadingImages(_emailData) {
  return getStaticChecklistOperationsEmailHeadingImages();
}
